import { useEffect, useState } from 'react';
import { Alert, Box, useMediaQuery, useTheme } from '@mui/material';
import { DialogContainer, DialogTitle, DialogBody, DialogActions } from '../../../common';
import SupplyOrderFormSection from './SupplyOrderFormSection';
import { getSupplyOrderApiErrorMessage } from '../utils/supplyOrdersUtils';
import { guardDialogClose } from '../../utils/actionLockUtils';

const SupplyOrderDialog = ({
  open,
  onClose,
  selectedOrder,
  onInputChange,
  onSelectChange,
  onSave,
  warehouses = [],
  warehousesLoading = false,
  providers = [],
  providersLoading = false,
  searchEnabled = true,
  onAddMaterial,
  onUpdateMaterialQuantity,
  onRemoveMaterial,
  isSaving = false,
  isEditMode = false,
  providerOnly = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (open) {
      setErrorMessage('');
    }
  }, [open]);

  const commonProps = {
    selectedOrder,
    onInputChange: (event) => {
      onInputChange(event);
      if (errorMessage) setErrorMessage('');
    },
    onSelectChange: (event) => {
      onSelectChange(event);
      if (errorMessage) setErrorMessage('');
    },
    isMobile,
    warehouses,
    warehousesLoading,
    providers,
    providersLoading,
    searchEnabled,
    onAddMaterial,
    onUpdateMaterialQuantity,
    onRemoveMaterial,
    providerOnly,
  };

  const handleSave = async () => {
    try {
      setErrorMessage('');
      const saved = await onSave();
      if (!saved) {
        setErrorMessage(
          'Completá origen, depósito destino y al menos un artículo con cantidad válida.'
        );
      }
    } catch (error) {
      console.error('Error al guardar la orden de abastecimiento:', error);
      setErrorMessage(
        getSupplyOrderApiErrorMessage(error, 'No se pudo guardar la orden de abastecimiento')
      );
    }
  };

  return (
    <DialogContainer
      open={open}
      onClose={guardDialogClose(isSaving, onClose)}
      size={isMobile ? 'small' : 'large'}
      minHeight={isMobile ? '70vh' : '60vh'}
    >
      <DialogTitle>
        {isEditMode
          ? 'Editar orden a proveedor'
          : providerOnly
            ? 'Nueva orden de materiales a proveedor'
            : 'Nueva orden de abastecimiento'}
      </DialogTitle>

      {errorMessage && (
        <Box sx={{ px: isMobile ? 2 : 3, pt: 2 }}>
          <Alert severity="error">{errorMessage}</Alert>
        </Box>
      )}

      <DialogBody>
        <SupplyOrderFormSection {...commonProps} />
      </DialogBody>

      <DialogActions
        handleClose={onClose}
        handleSave={handleSave}
        saveLabel={isEditMode ? 'Guardar cambios' : 'Crear borrador'}
        saveButtonProps={{ isLoading: isSaving }}
      />
    </DialogContainer>
  );
};

export default SupplyOrderDialog;
